// extracted by mini-css-extract-plugin
export default {"form":"auto-complete-select_form__P9gaS","label":"auto-complete-select_label__MOIVm","select":"auto-complete-select_select__CHqMR"};